/**
 * 车辆管理相关请求
 */
import request from "@/utils/request";

export interface CarListRequestParams {
  page: number;
  limit: number;
  sn?: string;
  plate_number?: string;
  cate_id?: number | Array<number>;
  installCaptain?: string;
  polygon?: Array<number>;
  carId?:any;
}

// 获取车辆列表数据
export const carListRequestPath = '/api/v2/car/list';
export const carListRequest = (data: CarListRequestParams) => {
  return request.post(carListRequestPath, data)
}

export const  carReportPath = '/api/v2/company/week/report/list'

export interface FleetReportListRequest {
  export?: boolean;
  /**
   * 风险等级
   */
  grade?: string;
  ignoreColumns?: string[];
  limit?: number;
  /**
   * 业务模式
   */
  mode?: string;
  /**
   * 车队名称
   */
  name?: string;
  page?: number;
  /**
   * 日期范围（week ~ week+6）
   */
  "query.dateRange"?: string;
  /**
   * 报告文件 OSS key（用于拼接 url，不导出）
   */
  "query.fileKey"?: string;
  /**
   * 车队等级（对应风险等级）
   */
  "query.grade"?: string;
  /**
   * 主键ID
   */
  "query.id"?: number;
  /**
   * 业务模式
   */
  "query.mode"?: string;
  /**
   * 车队名称
   */
  "query.name"?: string;
  /**
   * 风险车辆数
   */
  "query.riskCount"?: number;
  /**
   * 风险百分比（风险车辆数 / 运行车辆数 * 100，单位 0~100）
   */
  "query.riskPercent"?: number;
  /**
   * 运行车辆数
   */
  "query.runningCount"?: number;
  /**
   * 车队评分
   */
  "query.score"?: number;
  /**
   * 车辆总数
   */
  "query.totalCount"?: number;
  /**
   * 报告文件 URL
   */
  "query.url"?: string;
  /**
   * 统计日期（一周起始日）
   */
  "query.week"?: string;
  /**
   * 报告日期（需落在评分周期 [week, week+6] 区间内）
   */
  reportDate?: string;
  /**
   * 区间上界（闭区间，包含）
   */
  "riskPercentRanges[0].end"?: number;
  /**
   * 区间下界（开区间，不包含）
   */
  "riskPercentRanges[0].start"?: number;
  /**
   * 区间上界（闭区间，包含）
   */
  "scoreRanges[0].end"?: number;
  /**
   * 区间下界（开区间，不包含）
   */
  "scoreRanges[0].start"?: number;
  shard?: boolean;
  /**
   * 排序 正序： true 倒序：false
   */
  sort?: boolean;
  [property: string]: any;
}

export const reportListRequest = (params: FleetReportListRequest) => {
  return request.get<CompanyWeekReportListResponse>(carReportPath, {params})
}

/**
 * R«List«CompanyWeekReportListDto»»
 */
export interface CompanyWeekReportListResponse {
  code?: number | null;
  count?: number | null;
  data?: CompanyWeekReportListDto[] | null;
  ignoreColumns?: string[] | null;
  msg?: null | string;
  success?: boolean | null;
  [property: string]: any;
}

/**
 * 车队周评价报告列表展示/导出 DTO
 */
export interface CompanyWeekReportListDto {
  /**
   * 日期范围（week ~ week+6）
   */
  dateRange?: null | string;
  /**
   * 报告文件 OSS key（用于拼接 url，不导出）
   */
  fileKey?: null | string;
  /**
   * 车队等级（对应风险等级）
   */
  grade?: null | string;
  /**
   * 主键ID
   */
  id?: number | null;
  /**
   * 业务模式
   */
  mode?: null | string;
  /**
   * 车队名称
   */
  name?: null | string;
  /**
   * 风险车辆数
   */
  riskCount?: number | null;
  /**
   * 风险百分比（风险车辆数 / 运行车辆数 * 100，单位 0~100）
   */
  riskPercent?: number | null;
  /**
   * 运行车辆数
   */
  runningCount?: number | null;
  /**
   * 车队评分
   */
  score?: number | null;
  /**
   * 车辆总数
   */
  totalCount?: number | null;
  /**
   * 报告文件 URL
   */
  url?: null | string;
  /**
   * 统计日期（一周起始日）
   */
  week?: null | string;
  [property: string]: any;
}

// 生成报告
export const  createReportPath = 'api/v2/company/week/report/create'
export const createReportPathRequest = (data:any) => {
  return request.post(createReportPath, data)
}

//获取车辆位置数据（来源是abe设备或者是adas设备）
export const carLastLocationRequestPath = '/api/v2/car/location'
export const carLastLocationRequest = (data: any) => {
  return request.get(carLastLocationRequestPath, {params: data})
}

// 获取车辆列表数据
export const carListRequestPaths = '/api/v2/car/v1/list';
export const carListRequests = (data:any) => {
  return request.post(carListRequestPaths, data)
}

// 删除车辆
export const delCar = (id: any) => {
  return request.delete(`/api/v2/car/${id}`)
}

// 添加或编辑车辆建群
export const upsertCarRequest = (data: any) => {
  return request.post('/api/v2/car/upsert', data)
}

export interface UpdateCarOperatingStatusRequest {
  operatingStatus: string;
  [property: string]: any;
}

/**
 * 修改车辆运营状态
 */
export const updateCarOperatingStatusRequest = (carId: string | number, params: UpdateCarOperatingStatusRequest) => {
  return request.put('/api/v2/car/operatingStatus/' + carId, null, { params })
}

// 添加或编辑车辆建群
export const upsertCarRequests = (data: any) => {
  return request.post('/api/v2/car/v1/upsert', data)
}

// 添加或编辑运维备注
export const upsertOperationRequest = (data: any) => {
  return request.post('/api/v2/car/upsetOperateContent', data)
}

//// 更新设备状态（aeb ，adas）
export const updateServiceStateRequest = (data: any) => {
  return request.post('/api/v2/car/updateServiceState', data)
}

// 添加或编辑车辆电话
export const updateContactCarRequest = (data: any) => {
  return request.post('/api/v2/car/updateContact', data)
}

// 添加或编辑车辆状态
export const updateVehicleStateRequest = (data: any) => {
  return request.post('api/v2/car/updateVehicleState', data)
}



// 添加或编辑行驶证合同
export const drivingLicenseContractRequest = (data: any) => {
  return request.post('/api/v2/car/modify', data)
}

// 获取车辆详情
export const carDetailRequest = (id: string | number) => {
  return request.get(`/api/v2/car/detail/${id}`)
}

// 车辆解绑设备
export const unbindDeviceRequest = (data: { carId: number, deviceId?: number }) => {
  return request.put('/api/v2/car/unbind', data)
}

// 获取车辆信息(根据车牌号或者设备SN或者车架号)
export const findOneCarRequest = (params: { plateNumber?: string; sn?: string; frameNumber?: string; }) => {
  return request.get('/api/v2/car/findOne', { params })
}

// 获取车辆品牌列表
export const carBrandRequest = () => {
  return request.get('/api/v2/car/brands')
}

// 获取车辆车型列表
export const carModelRequest = () => {
  return request.get('/api/v2/car/models')
}

// 车辆批量导入的请求路径
export const carImportRequestPath = '/api/v2/car/import';


// 添加或编辑运维状态以及备注
export const upsetOperateContentRequests = (data: any) => {
  return request.post('/api/v2/car/upsetOperateContent', data)
}

// 添加或编辑用户配合度
export const updateVehicleCoordinateAbilityRequests = (data: any) => {
  return request.post('/api/v2/car/updateVehicleCoordinateAbility', data)
}
